module.exports = __webpack_public_path__ + "img/pillow_2.353b9cb5.png";